import polyglotI18nProvider from 'ra-i18n-polyglot';
import {en} from '../i18n/en';
import {fr} from '../i18n/fr';

const translations = { en, fr };

export const i18nProvider = polyglotI18nProvider(locale => translations[locale], 'en');
